import React, { useState, useEffect, useRef, useCallback } from "react";
import LoanDataService from "../services/LoanService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const LoanPr = (props) => {
  const [loan, setLoan] = useState([]);
  const loanRef = useRef();
  loanRef.current = loan;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveLoan = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    LoanDataService.getAll(target)
      .then((response) => setLoan(response.data || []))
      .catch((e) => { console.error(e); setLoan([]); });
  }, [owner]);

  useEffect(() => { retrieveLoan(); }, [retrieveLoan]);

  const deleteLoan = useCallback((rowIndex) => {
    const id = loanRef.current[rowIndex].id || loanRef.current[rowIndex]._id;
    LoanDataService.remove(id)
      .then(() => {
        const newArr = [...loanRef.current];
        newArr.splice(rowIndex, 1);
        setLoan(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/loan/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/loan/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = loanRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteLoan(idx);
  }, [deleteLoan]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={loan}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default LoanPr;
